export class MasterItem {

    constructor(
        public id: number = null,
        public partNumber: string = '',
        public mfgr_id: number = null,
        public warehouse_id: number = null,
        public inventorycategory_id: number = null,
        public inventorycategory_id2: number = null,
        public inventorycategory_id3: number = null,
        public inventorycategory_id4: number = null,
        public mastertypes_id: number = null,
        public clei: boolean = false,
        public bulk: boolean = false,
        public non_inventory: boolean = false,
        public weight: string = '',
        public descripcion: string = '',
        public ext_descripcion: string = '',
        public location_id: string = '',
        public scrapNotes: string = ''
    ) {}
}